import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';


Vue.use(Vuex);

/*
    App data is stored here
    Dynamic data from Firebase and Power Reviews will be GET in actions.js
    and saved here.

    [maybe we can use a persisted state plugin so we can keep the data offline?! -> see: vuex-persistedstate]
*/

export default new Vuex.Store({

  state: {

    product: {

      title: "",
      model: "Queen",
      price: "",
      promo: "",
      description: "",
      hardness: "",
      sizes: {},

      images: {

        as1: {
          profile: "/static/media/images/as1-profile.png",
          side: "/static/media/images/as1-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as2: {
          profile: "/static/media/images/as2-profile.png",
          side: "/static/media/images/as2-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as3: {
          profile: "/static/media/images/as3-profile.png",
          side: "/static/media/images/as3-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as4: {
          profile: "/static/media/images/as4-profile.png",
          side: "/static/media/images/as4-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        },

        as5: {
          profile: "/static/media/images/as5-profile.png",
          side: "/static/media/images/as5-side.png",
          screensaver: "/static/media/images/screensaver-1.jpg",
          slides: ["/static/media/images/screensaver-1.jpg", "/static/media/images/screensaver-2.jpg", "/static/media/images/screensaver-3.jpg", "/static/media/images/screensaver-4.jpg", "/static/media/images/screensaver-5.jpg", "/static/media/images/screensaver-6.jpg", "/static/media/images/screensaver-7.jpg", "/static/media/images/screensaver-8.jpg", "/static/media/images/screensaver-9.jpg", "/static/media/images/screensaver-10.jpg"]
        }

      },

      review: {

        score: '',
        votes: '',
        recommended_ratio: '',

      },

      reviews: []

    },

    compare: [

      {

        productName: "AS1",
        firmness: "Firm",
        review: {
          score: "5.0"
        },
        items: [
          { key: "Available Versions", value: "Memory Foam" },
          { key: "Sleep Style", value: "Stomach, Back" },
          { key: "Profile Height", value: "10-inch" },
          { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Bio-Core®: 8 inches', boxLarge: true },
          { key: 'Hybrid Mattress<br>Layer Construction', value: 'N/A', boxLarge: true },
          { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true },
          { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' },
          { key: "Fire Guard", value: "Green Guard fire sock" },
          { key: "Price (Memory Foam)", value: "Queen: $899<br>King: $1199", boxWide: true },

        ]
      },

      {

        productName: "AS2",
        firmness: "Medium Firm",
        review: {
          score: "5.0"
        },
        items: [
          { key: "Available Versions", value: "Memory Foam & Hybrid" },
          { key: "Sleep Style", value: "Stomach, Back" },
          { key: "Profile Height", value: "12-inch" },
          { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Affinity with HIVE®: 3 inches<br>Bio-Core®: 7 inches', boxLarge: true },
          { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 2 inches<br>Affinity: 1 inch<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true },
          { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity & Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true },
          { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' },
          { key: "Fire Guard", value: "Green Guard fire sock" },
          { key: "Price (Memory Foam/Hybrid)", value: "Queen: $999/$1299<br>King: $1299/$1599", boxWide: true },

        ]
      },

      {

        productName: "AS3",
        firmness: "Medium",
        review: {
          score: "5.0"
        },
        items: [
          { key: "Available Versions", value: "Memory Foam & Hybrid" },
          { key: "Sleep Style", value: "Side, Back, Combo" },
          { key: "Profile Height", value: "12-inch" },
          { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Affinity with HIVE®: 2 inches<br>Bio-Core®: 7 inches', boxLarge: true },
          { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true },
          { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true },
          { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' },
          { key: "Fire Guard", value: "Green Guard fire sock" },
          { key: "Price (Memory Foam/Hybrid)", value: "Queen: $1099/$1399<br>King: $1399/$1699", boxWide: true },

        ]
      },

      {

        productName: "AS4",
        firmness: "Medium Soft",
        review: {
          score: "5.0"
        },
        items: [
          { key: "Available Versions", value: "Memory Foam" },
          { key: "Sleep Style", value: "Side, Back, Combo" },
          { key: "Profile Height", value: "12-inch" },
          { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 4 inches<br>Affinity with HIVE®: 1 inch<br>Bio-Core®: 7 inches', boxLarge: true },
          { key: 'Hybrid Mattress<br>Layer Construction', value: 'N/A', boxLarge: true },
          { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Affinity with HIVE®: 2.3-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true },
          { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' },
          { key: "Fire Guard", value: "Green Guard fire sock" },
          { key: "Price (Memory Foam)", value: "Queen: $1299<br>King: $1599", boxWide: true },

        ]
      },

      {

        productName: "AS5",
        firmness: "Soft",
        review: {
          score: "5.0"
        },
        items: [
          { key: "Available Versions", value: "Memory Foam & Hybrid" },
          { key: "Sleep Style", value: "Side, Combo" },
          { key: "Profile Height", value: "14-inch" },
          { key: 'Memory Foam Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Active Flex: 2 inches<br>Affinity with HIVE®: 2 inches<br>Bio-Core®: 7 inches', boxLarge: true },
          { key: 'Hybrid Mattress<br>Layer Construction', value: 'Bio-Pur®: 3 inches<br>Active Flex: 2 inches<br>Pocketed Coils: 8 inches<br>Base Foam: 1 inch', boxLarge: true },
          { key: 'Density & ILD', value: 'Bio-Pur®: 4.0-lb density, 10 ILD<br>Active Flex: 3.0-lb density, 15 ILD<br>Affinity with HIVE®: 1.65-lb density, 17 ILD<br>Bio-Core®: 1.8-lb density, 33 ILD', boxXLarge: true },
          { key: 'Ultra-Breathable Cover', 'value': 'Ultra-breathable white cover with blue trim' },
          { key: "Fire Guard", value: "Green Guard fire sock" },
          { key: "Price (Memory Foam/Hybrid)", value: "Queen: $1699/$1999<br>King: $1999/$2299", boxWide: true },

        ]
      }


    ],

    technology: {

      cover: {

        title: "<div>CELLIANT<span>&reg;</span></div><br>COVER",
        content: "The Celliant cover is naturally antimicrobial and hypoallergenic, to provide a much safer sleep surface.<br><br>As you give off body heat, our fabric safely recycles this thermal energy into infrared light, using high-performance yarn made from 13 thermoreactive minerals.",
        video: "/static/media/videos/cover.mp4"

      },

      biopur: {

        title: "<div>Bio-Pur<span>&trade;</span></div><br>Foam",
        content: "Bio-Pur™ is designed to be responsive to you by relieving pressure points. The large open cell structure helps air to circulate, keeping your body temperature balanced from head to toe. When you lie down, you'll actively feel the relief.<br><br>The manufacturing process is environmentally friendly, producing zero emissions.",
        video: "/static/media/videos/biopur.mp4"

      },

      smt: {

        title: "SMT",
        content: "Surface Modification Technology (SMT) shapes precise channels into the foam, which allow air to circulate, providing a cooling effect.<br><br>The channels react to your body and create zones of superior pressure relief for pain points.",
        video: "/static/media/videos/smt.mp4"

      }

    }
  },

  mutations,

  actions

});



// WEBPACK FOOTER //
// ./src/vuex/store.js